import React, { useState } from "react";

import {  Col, FormLabel, Row, } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import {
  FabricStyleDetailInquiryCriteriaBean,
  MostRecentFabricInquiryCriteriaBean,
  RestCustomerModuleInitRequest,
  RestPageListBean,
} from "../ds/ds.js";
import {
  AlertToolBox,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
  ColumnDefinition
} from "../gui_components/UIComponents.js";
import { isEmptyArray } from "../gui_components/Util";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import { PopupInvoiceModule } from "../modules/ModuleUtil.js";
import { CustomerService } from "../services/CustomerService.js";
import { ReportService } from "../services/ReportService.js";
import CustomTable from "../gui_components/CustomTable.js";
class CustomerRecentFabricModule extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Customer Recent Sales Fabric Details",
      criteria: new MostRecentFabricInquiryCriteriaBean(),
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: false,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isShowExitButton: true,
      error_list: [],
      inquiryDataList: null,
      summaryData: null,
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMessage: [],
      success_list: [],
      moduleForPopup: [],
      recentFabricList: [],
      recentInvoiceList: [],
      recentInvoice: null,
      isShowInvoiceModule: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      isShowCriteriaView: true,
      isShowRecentInvoicePopup: false,
      is3PL: false,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    if (
      this.props.customerCode !== "" &&
      this.props.customerCode !== undefined
    ) {
      let temp_Criteria = this.state.criteria;
      temp_Criteria.customerCode = this.props.customerCode;
      let customerCode = this.props.customerCode;
      this.readCustomer(customerCode);
      this.setState({
        criteria: temp_Criteria,
        isShowCriteriaView: true,
        isShowResetButton: false,
        isShowExecuteButton: false,
        isShowClearCriteriaButton: false,
      });
      this.loadPage(1);
    }
  }
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let temp_Criteria = new MostRecentFabricInquiryCriteriaBean();
    temp_Criteria.companyCode = this.companyCode;
    temp_Criteria.customerCode = criteria.customerCode;
    this.loadCustomerRecentFabrics(criteria);
  };
  loadCustomerRecentFabrics = (criteria) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "loading...",
    });
    ReportService.inquireMostRecentFabricDetailsForCustomer(
      criteria,
      this.loadCustomerRecentFabricPageResponse,
      this.errorCallBack
    );
  };
  loadCustomerRecentFabricPageResponse = (response) => {
    if (response.data != null && response.data.resultBean != null) {
      let recentFabricList = [];
      let inquiryDataList = response.data.resultBean;
      if (!isEmptyArray(response.data.resultBean.fabricInfos)) {
        recentFabricList = response.data.resultBean.fabricInfos;
      }
      this.setState({
        isInquiryDatasFound: true,
        recentFabricList: recentFabricList,
        inquiryDataList: inquiryDataList,
        isLoading: false,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
    let customerCode = e.target.value;
    this.readCustomer(customerCode);
  };
  readCustomer = (customerCode) => {
    let readrestInput = new RestCustomerModuleInitRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.customerCode = customerCode;
    readrestInput.isLoadChildren = true;
    readrestInput.isLockRequired = false;
    CustomerService.initCustomer(
      readrestInput,
      this.editCustomerResponse,
      this.errorCallBack
    );
  };
  editCustomerResponse = (response) => {
    if (response.data.customerResponse) {
      if (response.data.customerResponse.customer != null) {
        let customerData = response.data.customerResponse.customer;
        let criteria = this.state.criteria;
        criteria.customerName = customerData.description;
        this.setState({ criteria: criteria });
      }
    }
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let criteria = new MostRecentFabricInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.customerName = "";
    this.setState({ criteria: criteria });
  };
  resetInquiry = () => {
    let criteria = new MostRecentFabricInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.customerName = "";
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: null,
      isShowPDFButton: false,
      isShowExcelButton: false,
    });
    this.hideAlertCallBack();
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  viewInvoiceModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowInvoiceModule: true,
          moduleForPopup: (
            <PopupInvoiceModule
              invoiceCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewRecentInvoiceDetails = (e, val, rowData) => {
    if (e.detail === 1) {
      if (val > 0) {
        this.setState({
          isShowRecentInvoicePopup: true,
          recentInvoice: rowData,
          isShowProgressBarPopup: true,
          progressLoadingText: "Reading Invoice...",
        });
        let criteria = this.state.criteria;
        let readrestInput = new FabricStyleDetailInquiryCriteriaBean();
        readrestInput.companyCode = criteria.companyCode;
        readrestInput.fabricStyleCode = rowData.fabricStyleCode;
        readrestInput.colorCode = rowData.colorCode;
        ReportService.getFabricStyleInvoiceDetails(
          readrestInput,
          this.loadFabricStyleInvoiceDetailsResponse,
          this.errorCallBack
        );
      }
    }
  };
  loadFabricStyleInvoiceDetailsResponse = (response) => {
    let inquiryList = response.data.pageList.infoBeans;
    if (inquiryList != null) {
      this.setState({
        recentInvoiceList: inquiryList,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowInvoiceModule: isOpen,
      isShowRecentInvoicePopup: isOpen,
      moduleForPopup: [],
    });
  };
  inquiryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Date", "invoiceDate", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Invoice#", "invoiceNumber", true)
        .setStyleDetails("left", "4", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewInvoiceModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item#" : "FabricStyle#",
          "fabricStyleCode",
          true
        )
        .setStyleDetails("left", "8", "", "wt-6", "wt-6")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(this.state.is3PL ? "Item Name" : "FabricStyle Name", "fabricStyleName", true)
        .setStyleDetails("left", "6", "", "wt-6", "wt-6")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "colorCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Price", "price", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Shipped Qty", "shippedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Sold Amt", "totalSoldAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "uomCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Total Amt", "netLineAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Total Qty", "totalShippedquantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewRecentInvoiceDetails, null)
    );
    return columns;
  };
  render() {
    let inquiryDataList = this.state.inquiryDataList;
    let recentFabricList = this.state.recentFabricList;
    let criteria = this.state.criteria;
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    return (
      <div>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={false}
          isShowPopup={this.state.isShowRecentInvoicePopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeModalCallBack}
          title={"Customer Recent Invoice Details"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          content={
            <div>
              <RecentInvoiceDetails
                {...this.state}
                recentInvoiceList={this.state.recentInvoiceList}
                recentInvoice={this.state.recentInvoice}
                handleSortingInvoiceChange={this.handleSortingInvoiceChange}
                viewInvoiceModule = {this.viewInvoiceModule}
              />
            </div>
          }
        />
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          loadingText={this.state.loadingText}
          isLoading={this.state.isLoading}
          pageTitle={
            this.state.is3PL
              ? "Customer Recent Sales Item Details"
              : "Customer Recent Sales Fabric Details"
          }
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          onModuleExit={this.onModuleExit}
        />
        {this.state.isShowCriteriaView ? (
          <CriteriaView {...this.state} onChange={this.onChange} />
        ) : null}
        <div className="mt-3">
          <CustomTable
            data={recentFabricList}
            columns={this.inquiryColumns()}
          />
        </div>
      </div>
    );
  }
}
export function CriteriaView(props) {
  const [show, setShow] = useState(false);
  const handleButton = () => setShow(!show);
  const onChange = (e) => props.onChange(e);
  let criteria = props.criteria;
  let inquiryDataList = props.inquiryDataList;
  return (
    <div>
      <Row>
        <Col sm="1">
          <FormLabel>Customer</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox value={criteria.customerCode} disabled={true} />
        </Col>
        <Col sm="3">
          <InputTextbox
            name="customerName"
            onChange={onChange}
            value={criteria.customerName}
            disabled={true}
          />
        </Col>
        {inquiryDataList != null && (
          <Col sm="1">
            <FormLabel>Total Sales Qty</FormLabel>
          </Col>
        )}
        {inquiryDataList != null && (
          <Col sm="2">
            <InputTextbox
              value={inquiryDataList.allFabricTotalQuantity}
              disabled={true}
            />
          </Col>
        )}
        {inquiryDataList != null && (
          <Col sm="1">
            <FormLabel>Total Sales Amt</FormLabel>
          </Col>
        )}
        {inquiryDataList != null && (
          <Col sm="2">
            <InputTextbox
              className="qty_input text-right summary_input"
              value={inquiryDataList.allFabricTotalSoldAmount}
              disabled={true}
            />
          </Col>
        )}
      </Row>
    </div>
  );
}
class RecentInvoiceDetails extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.countryRef = React.createRef();
    this.stateRef = React.createRef();
    this.cityRef = React.createRef();
  }
  handleSortingInvoiceChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingInvoiceChange(accessor);
  };
  customerRecentColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Date", "invoiceDate", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Invoice#", "invoiceNumber", true)
        .setStyleDetails("left", "4", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.props.viewInvoiceModule, null)
    ); 
    columns.push(
      new ColumnDefinition()
        .setDetails("Cust.P.O#", "customerPONumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Price", "price", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Shipped Qty", "shippedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
     return columns;
  };

  render() {
    let criteria = this.props.criteria;
    let recentInvoice = this.props.recentInvoice;
    let recentInvoiceList = this.props.recentInvoiceList;
    let inquiryDataList = this.props.inquiryDataList;
    return (
      <div className="header_div">
        <Row>
          <Col sm="2">
            <FormLabel>CustomerCode</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox value={criteria.customerCode} disabled={true} />
          </Col>
          <Col sm="2">
            {this.props.is3PL ? (
              <FormLabel>Item</FormLabel>
            ) : (
              <FormLabel>FabricStyle</FormLabel>
            )}
          </Col>
          <Col sm="2">
            <InputTextbox
              value={recentInvoice.fabricStyleCode}
              disabled={true}
            />
          </Col>
          <Col sm="4">
            <InputTextbox
              value={recentInvoice.fabricStyleName}
              disabled={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="2">
            <FormLabel>ColorCode</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox value={recentInvoice.colorCode} disabled={true} />
          </Col>
          {inquiryDataList != null && (
            <Col sm="2">
              <FormLabel>Total Sales Qty</FormLabel>
            </Col>
          )}
          {inquiryDataList != null && (
            <Col sm="2">
              <InputTextbox
                value={inquiryDataList.allFabricTotalQuantity}
                disabled={true}
              />
            </Col>
          )}
          {inquiryDataList != null && (
            <Col sm="2">
              <FormLabel>Total Sales Amt</FormLabel>
            </Col>
          )}
          {inquiryDataList != null && (
            <Col sm="2">
              <InputTextbox
                className="qty_input text-right summary_input"
                value={inquiryDataList.allFabricTotalSoldAmount}
                disabled={true}
              />
            </Col>
          )}
        </Row>
        <div className="mt-3">
          <CustomTable
            data={recentInvoiceList}
            columns={this.customerRecentColumns()}
          />
        </div>
      </div>
    );
  }
}
function CustomerRecentFabricInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <CustomerRecentFabricModule {...props} name="" /> <br />
    </div>
  );
}

export default CustomerRecentFabricInquiry;
